import { InputField, SearchContainer } from '@ui/SearchField/styles'
import { Inline } from '../../layout/Inline'
import Search from '@images/Search.svg'
import React, { ChangeEvent, CSSProperties, FC } from 'react'
import { observer } from 'mobx-react-lite'

interface SearchProps {
	data: string
	setData: (value: string) => void
	onSearch?: (value: string) => void
	styles?: CSSProperties
	placeholder?: string
	iconPosition?: 'left' | 'right'
}

export const SearchField: FC<SearchProps> = observer(
	({
		data,
		setData,
		onSearch,
		styles,
		placeholder = 'Введите ваш запрос...',
		iconPosition = 'right',
	}) => {
		const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
			setData(e.target.value)
			if (onSearch) onSearch(e.target.value)
		}

		const handleSearch = () => {
			if (onSearch) onSearch(data)
		}

		const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter' && onSearch) {
				onSearch(data)
			}
		}

		const icon = <img src={Search} alt={'найти'} onClick={handleSearch} />

		return (
			<SearchContainer style={styles}>
				<Inline justify={'space-between'} align={'center'} gap={12}>
					{iconPosition === 'left' && icon}
					<InputField
						placeholder={placeholder}
						onKeyPress={handleKeyPress}
						onChange={handleInputChange}
						value={data}
					/>
					{iconPosition === 'right' && icon}
				</Inline>
			</SearchContainer>
		)
	},
)
